import { h, watchEffect } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserInfoStore } from '@/store'
export const OKRNOTSAMEOFFICE = 'okr-not-same-office',
  OKRNOAPP = 'has-no-okr-app',
  PERFNOAPP = 'has-no-perf-app',
  PERFNOPROJECT = 'has-no-perf-project'
export const QUERYKEY = 'reason',
  CALLBACKNAME = 'callback'
import router from '@/router'
let isFirstNoAuthFlag = true
const toOkrIndex = () => { router.replace('/okr') }
const toPerfIndex = () => { router.replace('/perf') }
export const NOAUTHMAP = {
  [OKRNOTSAMEOFFICE]: {
    noAuthTitle: h('span', {}, [
      h('span', {}, '无此用户访问权限'),
    ]),
    noAuthInfo: h('span', {}, [
      h('span', {}, '您可以返回'),
      h('span', { class: 'span-btn', style: 'margin: 0 5px', onClick: toOkrIndex }, '我的OKR'),
    ]),
    callback() {}
  },
  [OKRNOAPP]: {
    noAuthTitle: '无OKR访问权限',
    noAuthInfo: '',
    callback() {
      let userInfoStore = useUserInfoStore()
      return watchEffect(() => {
        let { isCanPreviewOkr } = storeToRefs(userInfoStore)
        if (isCanPreviewOkr.value === true) {
          router.replace('/okr')
        }
      })
    }
  },
  [PERFNOAPP]: {
    noAuthTitle: '无绩效访问权限',
    noAuthInfo: '',
    callback() {
      let userInfoStore = useUserInfoStore()
      return watchEffect(() => {
        let { isCanPreviewPerf } = storeToRefs(userInfoStore)
        if (isCanPreviewPerf.value === true) {
          router.replace('/perf')
        }
      })
    }
  },
  [PERFNOPROJECT]: {
    noAuthTitle: '无此项目或未获得访问权限',
    noAuthInfo: h('span', {}, [
      h('span', {}, '您可以返回'),
      h('span', { class: 'span-btn', style: 'margin: 0 5px', onClick: toPerfIndex }, '我的绩效'),
    ]),
    callback() {}
  }
}
export function goNoAuth(key = '') {
  router.replace({
    path: '/no-auth',
    query: {
      [QUERYKEY]: key
    }
  })
  isFirstNoAuthFlag = false
}
export function resetFlag() {
  isFirstNoAuthFlag = true
}
export function getFlag() {
  return isFirstNoAuthFlag
}
